module.exports = __webpack_public_path__ + "static/media/zind_rugarama2.bb6fe7e9.jpg";